import { MapPin } from "lucide-react";
import { SERVICE_AREAS } from "../data/mock";
import { useInView } from "../hooks/useInView";

export const ServiceAreasGrid = () => {
  const [ref, isInView] = useInView();
  return (
    <section id="areas" className="py-16 lg:py-20 bg-white relative overflow-hidden">
      <div className="absolute -top-24 right-1/4 w-[400px] h-[400px] bg-sky-50/40 rounded-full blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 relative">
        <div className="text-center max-w-2xl mx-auto mb-10" ref={ref}>
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-sky-600 tracking-wider uppercase mb-4">
            <MapPin className="w-4 h-4" /> Service Areas
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight mb-4">
            Free pickup & delivery across Jaipur
          </h2>
          <p className="text-slate-500 leading-relaxed">
            We cover {SERVICE_AREAS.length}+ neighbourhoods across Jaipur. Don't see yours? Message us — we're expanding fast.
          </p>
        </div>

        <div className={`flex flex-wrap justify-center gap-2 sm:gap-2.5 transition-all duration-700 ${isInView ? "opacity-100" : "opacity-0"}`}>
          {SERVICE_AREAS.map((a, i) => (
            <span
              key={i}
              className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-slate-50 hover:bg-sky-50 border border-slate-200 hover:border-sky-300 text-sm font-medium text-slate-700 hover:text-sky-700 transition-colors cursor-default"
              data-testid={`area-tag-${i}`}
              style={{ transitionDelay: `${i * 20}ms` }}
            >
              <span className="w-1.5 h-1.5 bg-lime-500 rounded-full" />
              {a}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
